import React, {useEffect, useState}                                                       from 'react'
import {Box, Button, FormControl, InputLabel, MenuItem, Modal, Paper, Select, Typography} from '@mui/material'
import getSupabase
                                                                                          from '../../util/supabase-utils'

const AddLicenseModal = ({ open, onClose, onAddLicense }) => {
	const [categories, setCategories] = useState([])
	const [packages, setPackages] = useState([])
	const [options, setOptions] = useState([])

	const [selectedCategory, setSelectedCategory] = useState('')
	const [selectedPackage, setSelectedPackage] = useState('')
	const [selectedOption, setSelectedOption] = useState('')

	useEffect(() => {
		if (open) {
			fetchCategories()
		}
	}, [open])

	const fetchCategories = async () => {
		const { data, error } = await getSupabase()
			.from('category')
			.select('*')
			.order('name')
		if (!error) setCategories(data || [])
	}

	const handleCategoryChange = async (e) => {
		const categoryId = e.target.value
		setSelectedCategory(categoryId)
		setSelectedPackage('')
		setSelectedOption('')
		setPackages([])
		setOptions([])

		const { data, error } = await getSupabase()
			.from('package')
			.select('*')
			.eq('category_id', categoryId)
			.is('archived_at', null)
			.not('published_at', 'is', null)
			.order('name')
		if (!error) setPackages(data || [])
	}

	const handlePackageChange = async (e) => {
		const packageId = e.target.value
		setSelectedPackage(packageId)
		setSelectedOption('')
		setOptions([])

		const { data, error } = await getSupabase()
			.from('package_option')
			.select('*')
			.eq('package_id', packageId)
			.order('name')
		if (!error) setOptions(data || [])
	}

	const handleSave = async () => {
		// Save logic placeholder
		await onAddLicense(selectedCategory, selectedPackage, selectedOption)
		setSelectedCategory('')
		setSelectedPackage('')
		setSelectedOption('')
		onClose()
	}

	const handleCancel = () => {
		onClose()
		setSelectedCategory('')
		setSelectedPackage('')
		setSelectedOption('')
	}

	return (
		<Modal open={open} onClose={handleCancel}>
			<Box
				display="flex"
				justifyContent="center"
				alignItems="center"
				height="100vh"
			>
				<Paper sx={{ p: 3, width: 400 }}>
					<Typography variant="h6" gutterBottom>
						Add License
					</Typography>

					<FormControl fullWidth sx={{ mt: 2 }}>
						<InputLabel>Category</InputLabel>
						<Select value={selectedCategory} onChange={handleCategoryChange}>
							{categories.map((cat) => (
								<MenuItem key={cat.id} value={cat.id}>
									{cat.name}
								</MenuItem>
							))}
						</Select>
					</FormControl>

					<FormControl fullWidth sx={{ mt: 2 }} disabled={!selectedCategory}>
						<InputLabel>Package</InputLabel>
						<Select value={selectedPackage} onChange={handlePackageChange}>
							{packages.map((pkg) => (
								<MenuItem key={pkg.id} value={pkg.id}>
									{pkg.name}
								</MenuItem>
							))}
						</Select>
					</FormControl>

					<FormControl fullWidth sx={{ mt: 2 }} disabled={!selectedPackage}>
						<InputLabel>Option</InputLabel>
						<Select
							value={selectedOption}
							onChange={(e) => setSelectedOption(e.target.value)}
						>
							{options.map((opt) => (
								<MenuItem key={opt.id} value={opt.id}>
									{opt.name}
								</MenuItem>
							))}
						</Select>
					</FormControl>

					<Box display="flex" justifyContent="flex-end" mt={3}>
						<Button onClick={handleCancel} sx={{ mr: 2 }}>
							Cancel
						</Button>
						<Button
							variant="contained"
							color="primary"
							disabled={!selectedCategory || !selectedPackage || !selectedOption}
							onClick={handleSave}
						>
							Save
						</Button>
					</Box>
				</Paper>
			</Box>
		</Modal>
	)
}

export default AddLicenseModal
